import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Container, Row, } from 'reactstrap';
import NumberFormat from "react-number-format";
import { fileDownload, balanceFields } from '../helpers/helpers';

import { API, BASE_URL } from '../CONST';
import BaseModal from './UI/BaseModal';
import FileTable from './shared/FileTable';
import auth from "../helpers/auth";


export default class DetalleLinea extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mov: null
    }
  }

  componentDidMount() {
    const { movimientoId, isGrupo } = this.props;
    const rutaMovimientos = isGrupo ? API.movimientosGrupo : API.movimientos;
    auth.fetch(`${BASE_URL}${rutaMovimientos}${movimientoId}/`,)
      .then(response => this.setState({ mov: response }));
  }

  render() {
    const {handleModal, modalOpen, afianzado, isGrupo } = this.props;
    const { mov } = this.state;
    const afianzadoNombre = isGrupo ? afianzado.nombre : `${afianzado.rut} ${afianzado.nombre}`

    if (!mov || !afianzado) {
      return null
    }

    return (
      <BaseModal
        handleModal={handleModal}
        modalOpen={modalOpen}
        title={`Detalle ${mov.tipo_cambio.descripcion} ${mov.tipo.descripcion}`}
        type="modal-lg"
      >
        <Container className="detalle-line-body" fluid>
          {mov.movimiento_origen ? (
            <Row>
              <Col>
                <div className="label">Afianzado original</div>
                <p className="value">
                  {`${mov.movimiento_origen.linea_garantia.organizacion.rut} ${mov.movimiento_origen.linea_garantia.organizacion.nombre}`}
                </p>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col>
                <div className="label">Afianzado</div>
                <p className="value">
                  {`${afianzadoNombre}`}
                </p>
              </Col>
            </Row>
          )}
          {mov.respaldo && mov.respaldo.avales && (
            <Row>
              <Col>
                <div className="label">Avales</div>
                <p className="value">
                  {mov.respaldo.avales.map(aval => (
                    <div>{`${aval.rut} ${aval.nombre}`}</div>
                  ))}
                </p>
              </Col>
            </Row>
          )}
          <Row>
            <Col sm="4">
              <div className="label">
                Monto UF
              </div>
              <p className="value">
                <NumberFormat
                  decimalScale="2"
                  fixedDecimalScale
                  decimalSeparator=","
                  displayType="text"
                  value={mov.cambio_monto}
                  thousandSeparator="."
                />
              </p>
            </Col>
            <Col sm="4">
              <div className="label">
                Nuevo Monto
              </div>
              <p className="value">
                <NumberFormat
                  decimalScale="2"
                  fixedDecimalScale
                  decimalSeparator=","
                  displayType="text"
                  value={mov.balance[balanceFields[mov.tipo.nemotecnico]]}
                  thousandSeparator="."
                />
              </p>
            </Col>
            {mov.tipo.nemotecnico === 'linea' && (
              <Col sm="4">
                <div className="label">
                  Monto Límite
                </div>
                {mov.balance.limite_contrafianza > 0 ? (
                  <p className="value">
                    <NumberFormat
                      decimalScale="2"
                      fixedDecimalScale
                      decimalSeparator=","
                      displayType="text"
                      value={mov.balance.limite_contrafianza}
                      thousandSeparator="."
                    />
                  </p>
                ) : (
                  <p className="value">
                    Sin límite
                  </p>
                )}
              </Col>
            )}
          </Row>
          {mov.justificacion && (
            <Row>
              <Col>
                <div className="label">
                  Justificación
                </div>
                <p className="value">
                  {mov.justificacion}
                </p>
              </Col>
            </Row>
          )}
          {mov.respaldo && mov.respaldo.tipo.nemotecnico === 'adenda' && (
            <>
              <Row>
                <Col>
                  <div className="label">Adenda</div>
                  <p className="value">
                    <Button
                      className="form-button cancelar text-left"
                      onClick={() => {
                        fileDownload(`${BASE_URL}${API.download}/`, mov.respaldo.contrato.id)
                      }}
                    >
                      Descargar
                    </Button>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="form-block" sm={{ size: 4 }}>
                  <div className="label">
                    Aumento límite UF
                  </div>
                  <p className="value">
                    <NumberFormat
                      decimalScale="2"
                      fixedDecimalScale
                      decimalSeparator=","
                      displayType="text"
                      value={mov.respaldo.cambio_limite_contrafianza}
                      thousandSeparator="."
                    />
                  </p>
                </Col>
              </Row>
            </>
          )}
          {mov.respaldo && mov.respaldo.tipo.nemotecnico === 'contrafianza' && (
            <>
              <Row>
                <Col>
                  <div className="label">Contrafianza</div>
                  <p className="value">
                    <Button
                      className="form-button cancelar text-left"
                      onClick={() => {
                        fileDownload(`${BASE_URL}${API.download}/`, mov.respaldo.contrato.id)
                      }}
                    >
                      Descargar
                    </Button>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="form-block" sm={{ size: 4 }}>
                  <div className="label">
                    Límite Contrafianza UF
                  </div>
                  {mov.balance.limite_contrafianza > 0 ? (
                    <p className="value">
                      <NumberFormat
                        decimalScale="2"
                        fixedDecimalScale
                        decimalSeparator=","
                        displayType="text"
                        value={mov.balance.limite_contrafianza}
                        thousandSeparator="."
                      />
                    </p>
                  ) : (
                    <p className="value">
                      Sin límite
                    </p>
                  )}
                </Col>
              </Row>
            </>
          )}
          {mov.documentos && (
            <Row>
              <Col>
                <div className="label">Archivos</div>
                <p className="value">
                  <FileTable
                    fileList={mov.documentos}
                    downloadUrl={`${BASE_URL}${API.download}/`}
                    readOnly
                  />
                </p>
              </Col>
            </Row>
          )}
        </Container>
      </BaseModal>
    )
  }
}

DetalleLinea.propTypes = {
  movimientoId: PropTypes.number.isRequired,
  handleModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  afianzado: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    rut: PropTypes.string,
  }).isRequired,
  isGrupo: PropTypes.bool,
};

DetalleLinea.defaultProps = {
  isGrupo: false,
}
